var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { Box, Grid, CircularProgress } from '@mui/material';
import moment from 'moment-timezone';
import { isEmpty } from 'lodash';
import GraphAPI from 'utilities';
import { getTimestamp } from 'globals/global.functions';
import { DATE_FORMAT_SHORT_YEAR, DATE_FORMAT_SHORT, } from 'globals/global.constants';
import { getFormattedDate } from 'globals/date.functions';
import { GraphView } from 'globals/enums';
import { BodyWeight } from './components/BodyWeight.component';
import { BodyComposition } from './components/BodyComposition.component';
import { BodyHydration } from './components/BodyHydration.component';
import { wellnessDashboardStyle } from '../../WellnessDashboard.style';
import { getAuditHistory } from 'common/EditAndDisable/PauseManagement.action';
var BodyHealthComponent = function () {
    var _a, _b, _c, _d;
    var _e = useAppSelector(function (state) { return state.wellnessDashboard; }), currentState = _e.currentState, startTime = _e.startTime, endTime = _e.endTime, reRender = _e.reRender;
    var classes = wellnessDashboardStyle().classes;
    var dispatch = useAppDispatch();
    var _f = useState([]), summary = _f[0], setSummary = _f[1];
    var _g = useState(false), triggerRender = _g[0], setTriggerRender = _g[1];
    var _h = useState(null), lastRecordedDate = _h[0], setLastRecordedDate = _h[1];
    var _j = useState([]), difference = _j[0], setDifference = _j[1];
    var _k = useState([]), graph = _k[0], setGraph = _k[1];
    var _l = useState(''), weightDayStartTime = _l[0], setWeightDayStartTime = _l[1];
    var _m = useState(''), weightDayEndTime = _m[0], setWeightDayEndTime = _m[1];
    var _o = useState({
        loading: true,
        subTitle: '',
        noRecordFound: false,
    }), config = _o[0], setConfig = _o[1];
    var _p = useState(null), auditInfo = _p[0], setAuditInfo = _p[1];
    var isProfilePaused = (_b = (_a = auditInfo === null || auditInfo === void 0 ? void 0 : auditInfo.pauseStatus) === null || _a === void 0 ? void 0 : _a.profile) !== null && _b !== void 0 ? _b : false;
    var isDevicePaused = (_d = (_c = auditInfo === null || auditInfo === void 0 ? void 0 : auditInfo.pauseStatus) === null || _c === void 0 ? void 0 : _c.device) !== null && _d !== void 0 ? _d : false;
    var isBodyHealthEditDisabled = isProfilePaused || isDevicePaused;
    useEffect(function () {
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(getAuditHistory())];
                    case 1:
                        info = _a.sent();
                        setAuditInfo(info);
                        return [2 /*return*/];
                }
            });
        }); };
        run();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var lastAvailableKey = useMemo(function () {
        if (!isEmpty(summary.all_data)) {
            return Object.keys(summary.all_data)[Object.keys(summary.all_data).length - 1];
        }
        return null;
    }, [summary]);
    var graphTickValues = useMemo(function () {
        var tempArray = [];
        var startDate = moment(getTimestamp(currentState === GraphView.DAY ? weightDayStartTime : startTime));
        var endDate = moment(getTimestamp(currentState === GraphView.DAY ? weightDayEndTime : endTime)).add(1, GraphView.DAY);
        while (endDate.diff(startDate, 'days') > 0) {
            tempArray.push(startDate.format(DATE_FORMAT_SHORT));
            startDate.add(1, 'days');
        }
        return tempArray;
    }, [startTime, endTime, weightDayStartTime, weightDayEndTime]);
    var isGraphEmpty = useMemo(function () {
        var checkEmptyGraph = isEmpty(Object.keys(summary.all_data || {}).filter(function (data) {
            return graphTickValues.includes(moment(getTimestamp(data)).format(DATE_FORMAT_SHORT));
        }));
        return checkEmptyGraph;
    }, [summary, graphTickValues]);
    useEffect(function () {
        if (startTime && endTime && (reRender || triggerRender)) {
            setTriggerRender(false);
            var weightGraphStartTime = moment(getTimestamp(startTime))
                .clone()
                .startOf(GraphView.WEEK)
                .format('x');
            var weightGraphEndTime = moment(getTimestamp(startTime))
                .clone()
                .endOf(GraphView.WEEK)
                .format('x');
            setWeightDayStartTime(weightGraphStartTime * 1000000);
            setWeightDayEndTime(weightGraphEndTime * 1000000);
            var getBodyHealthMeasurement = GraphAPI.fetchBodyHealthMeasurement(startTime, endTime);
            var getBodyHealthDifference = GraphAPI.fetchBodyHealthDifference(startTime, endTime);
            var getWeightGraph = GraphAPI.fetchBodyHealthGraph('weight', currentState === GraphView.DAY
                ? weightGraphStartTime * 1000000
                : startTime, currentState === GraphView.DAY ? weightGraphEndTime * 1000000 : endTime);
            var getHydrationGraph = GraphAPI.fetchBodyHealthGraph('hydration', currentState === GraphView.DAY
                ? weightGraphStartTime * 1000000
                : startTime, currentState === GraphView.DAY ? weightGraphEndTime * 1000000 : endTime);
            setConfig(__assign(__assign({}, config), { loading: true }));
            Promise.all([
                getBodyHealthMeasurement,
                getBodyHealthDifference,
                getWeightGraph,
                getHydrationGraph,
            ]).then(function (res) {
                var measurement = res[0], bodyHealthDifference = res[1], weight = res[2], hydration = res[3];
                setConfig(__assign(__assign({}, config), { loading: false }));
                setSummary(__assign({}, measurement));
                setDifference(__assign({}, bodyHealthDifference));
                setGraph({
                    weight: weight,
                    hydration: hydration,
                });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startTime, endTime, reRender, triggerRender]);
    useEffect(function () {
        var lastRecDate = getFormattedDate(lastAvailableKey, DATE_FORMAT_SHORT_YEAR);
        if (getFormattedDate(startTime) !== getFormattedDate(lastAvailableKey) &&
            currentState === GraphView.DAY &&
            !isEmpty(summary)) {
            setLastRecordedDate(lastRecDate);
        }
        else if (isGraphEmpty && !isEmpty(summary)) {
            setLastRecordedDate(lastRecDate);
        }
        else {
            setLastRecordedDate(null);
        }
    }, [summary, lastAvailableKey, isGraphEmpty]);
    return (_jsxs(Grid, { container: true, spacing: 2, "data-testid": 'body-health-container', children: [_jsx(Grid, { item: true, sm: 12, children: _jsx(Box, { className: classes.cardContainer, p: 2, children: config.loading ? (_jsx(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', children: _jsx(CircularProgress, {}) })) : (_jsx(BodyWeight, { graph: graph, difference: difference, summary: summary, type: currentState, lastRecordedDate: lastRecordedDate, graphTickValues: graphTickValues, reRender: function () { return setTriggerRender(true); }, disabled: isBodyHealthEditDisabled })) }) }), currentState !== GraphView.DAY && (_jsx(Grid, { item: true, sm: 12, children: _jsx(Box, { className: classes.cardContainer, p: 2, children: config.loading ? (_jsx(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', children: _jsx(CircularProgress, {}) })) : (_jsx(BodyComposition, { difference: difference, summary: summary, type: currentState, lastRecordedDate: lastRecordedDate, lastAvailableKey: lastAvailableKey, graphTickValues: graphTickValues })) }) })), _jsx(Grid, { item: true, sm: 12, children: _jsx(Box, { className: classes.cardContainer, p: 2, children: config.loading ? (_jsx(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', children: _jsx(CircularProgress, {}) })) : (_jsx(BodyHydration, { difference: difference, summary: summary, type: currentState, lastRecordedDate: lastRecordedDate, graphTickValues: graphTickValues, reRender: function () { return setTriggerRender(true); }, graph: graph, disabled: isBodyHealthEditDisabled })) }) })] }));
};
export { BodyHealthComponent };
